import React from 'react';

// Renders text in view mode, becomes an input/textarea in edit mode
export function EField({ value, onChange, multiline = false, className = '', placeholder = '', mode = 'view', as: As = 'span' }) {
  if (mode === 'edit') {
    if (multiline) {
      return (
        <textarea
          value={value || ''}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          rows={Math.max(2, String(value || '').split('\n').length + 1)}
          className={`w-full bg-ee-card2/60 border border-gold/30 focus:border-gold rounded-md p-2 outline-none text-inherit ${className}`}
        />
      );
    }
    return (
      <input
        value={value || ''}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        className={`w-full bg-ee-card2/60 border border-gold/30 focus:border-gold rounded-md px-2 py-1 outline-none text-inherit ${className}`}
      />
    );
  }
  // view mode
  const text = String(value ?? '');
  // preserve newlines (e.g., Hero title "Discover Your\nInherent Worth")
  if (text.includes('\n')) {
    return (
      <As className={className}>
        {text.split('\n').map((line, i) => (
          <React.Fragment key={i}>{line}{i < text.split('\n').length - 1 && <br />}</React.Fragment>
        ))}
      </As>
    );
  }
  return <As className={className}>{text}</As>;
}

export function FieldRow({ label, children }) {
  return (
    <div className="mb-2">
      <label className="block text-[11px] uppercase tracking-wider text-gold/80 mb-1">{label}</label>
      {children}
    </div>
  );
}
